import { useVcmConfirm } from '../components/VcmModalConfirm/useVcmConfirm'
import { useUpdateAlmanacFile } from './queries/almanacFiles/useUpdateAlmanacFile'
import { showToastMessage } from '../common/ToastMessage/ShowToastMessage'
import { showErrorMessageToast } from '../common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { AlmanacFileSummary, FileType } from 'types'
import { useConfirmModal } from './useConfirmModal'
import { VcmDisabledModalConfirm } from '../components/VcmModalConfirm/VcmDisableModalConfirm'

interface Options {
  onConfirm: () => void
  onChange: (versionControlMode: boolean) => void
  onUpdated: (almanacFile: AlmanacFileSummary) => void
}

export const useUpdateVcm = (key: string, type: FileType) => {
  const { mutate: updateAlmanacFile, isLoading, ...rest } = useUpdateAlmanacFile({ key })
  const confirmEnabled = useVcmConfirm(type)
  const confirmDisabled = useConfirmModal(VcmDisabledModalConfirm)

  const confirm = (versionControlMode: boolean) => (versionControlMode ? confirmEnabled() : confirmDisabled())

  const updateVcm = async (versionControlMode: boolean, options?: Partial<Options>) => {
    if (isLoading) {
      return
    }

    let toast = () => {}
    options?.onChange?.(versionControlMode)
    const isConfirmed = await confirm(versionControlMode)

    if (!isConfirmed) {
      return
    }

    toast = showToastMessage(`${versionControlMode ? 'Enabling' : 'Disabling'} Version Control Mode...`, 'loading')
    options?.onConfirm?.()
    updateAlmanacFile(
      { version_control_mode: versionControlMode },
      {
        onSuccess: ({ almanac_file }) => {
          options?.onUpdated?.(almanac_file)
        },
        onError: (e) => {
          showErrorMessageToast(e.message)
        },
        onSettled: () => {
          toast()
        },
      },
    )
  }

  return { updateVcm, isLoading, ...rest }
}
